import { useCallback, useState } from 'react';
import { StyledTextInput } from './TextInput.styled';

const TextInput = ({ initText = '', limit = 128, placeholder = '', onChange = null, disabled = false}) => {
  const [focused, setFocused] = useState(false);
  const [text, setText] = useState(initText.slice(0, limit));

  const setTextOnChange = useCallback((data) => {
    setText(data.slice(0, limit));
    if (onChange) {
      onChange(data.slice(0, limit));
    }
  }, [limit, setText]);
  return (
    <StyledTextInput $focused={focused}>
      <input
        disabled={disabled}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        value={text}
        onChange={(event) => setTextOnChange(event.target.value)}
        placeholder={placeholder}
      />
    </StyledTextInput>
  );
}

export default TextInput;
